import { create } from 'zustand';
import type { WardInfo } from '@/types/ward';
import { eventService, WARD_EVENTS } from '@/services/EventService';

interface ComparisonState {
  // Danh sách phường được chọn để so sánh (tối đa 4)
  selectedWards: WardInfo[];
  
  // Trạng thái
  isComparing: boolean;
  maxSelections: number;
  
  // Actions
  addWard: (ward: WardInfo) => void;
  removeWard: (wardId: number) => void;
  clearSelection: () => void;
  toggleComparing: () => void;
  isWardSelected: (wardId: number) => boolean;
  canAddMore: () => boolean;
}

export const useComparisonStore = create<ComparisonState>((set, get) => ({
  // State
  selectedWards: [],
  isComparing: false,
  maxSelections: 4,
  
  // Actions
  addWard: (ward) => set((state) => {
    if (state.selectedWards.length >= state.maxSelections) return state;
    if (state.selectedWards.some(w => w.objectid === ward.objectid)) return state;
    
    const newState = { selectedWards: [...state.selectedWards, ward] };
    eventService.emit(WARD_EVENTS.COMPARISON_ADDED, ward);
    return newState;
  }),
  
  removeWard: (wardId) => set((state) => {
    const wardToRemove = state.selectedWards.find(w => w.objectid === wardId);
    if (wardToRemove) {
      eventService.emit(WARD_EVENTS.COMPARISON_REMOVED, wardToRemove);
    }
    return {
      selectedWards: state.selectedWards.filter(w => w.objectid !== wardId)
    };
  }),
  
  clearSelection: () => {
    set({ selectedWards: [] });
  },
  
  toggleComparing: () => set((state) => {
    const newIsComparing = !state.isComparing;
    eventService.emit(WARD_EVENTS.COMPARISON_MODE_CHANGED, newIsComparing);
    return { isComparing: newIsComparing };
  }),
  
  isWardSelected: (wardId) => {
    return get().selectedWards.some(w => w.objectid === wardId);
  },
  
  canAddMore: () => {
    const state = get();
    return state.selectedWards.length < state.maxSelections;
  },
}));